import { z } from 'zod'

export const defaultSystemNameSchema = z
	.string()
	.min(3, 'Min length 3 characters')
	.max(32, 'Max length 32 characters')
	.regex(/^[a-z0-9._-]+$/, 'Invalid: only a-z and symbols: . - _')
